// extracted by mini-css-extract-plugin
export var currencyInput = "_jp-1";
export var currencySymbol = "_jp-0";